import { Dialog } from "@mui/material";
import { SplashPage } from "contexts/Subscription";
import { Plans } from "schemas/payments";

import StripeCheckout from "components/StripeCheckout";

interface IProps {
  open: boolean;
  handleClose: () => void;
}

export default function UpgradeDialog({ open, handleClose }: IProps) {
  return (
    <Dialog
      open={open}
      scroll="body"
      onClose={handleClose}
      fullWidth
      maxWidth="md"
    >
      <StripeCheckout
        inDialog
        openCheckoutDialog={{
          plan: Plans.VA_YEARLY,
          pageSource: window.location.pathname,
          source: "Onboarding Demo",
          splashPageSource: SplashPage.instagram,
        }}
        onSuccess={() => {}}
      />
    </Dialog>
  );
}
